import { useCallback, useMemo } from 'react';
import { routingService } from 'services/routing';
import { useCompanyIdBasedOnUrl } from 'shared/hooks/useCompanyIdBasedOnUrl';
import { getPath, Path } from 'urlBuilder';

import { wizardSteps } from '../../../resources/constants';
import { useWizardActiveStep } from './useWizardActiveStep';

export const useWizardNavigation = () => {
    const { companyId } = useCompanyIdBasedOnUrl();
    const activeStep = useWizardActiveStep();

    const stepIndex = useMemo(() => wizardSteps.findIndex((step) => step === activeStep), [activeStep]);

    const navigate = useCallback(
        (nextStepIndex: number) => {
            if (nextStepIndex >= 0 && wizardSteps.length - 1 >= nextStepIndex) {
                routingService.push(getPath(Path.walletsKycWizard, companyId, wizardSteps[nextStepIndex]));
            }
        },
        [companyId]
    );

    const navigateNext = useCallback(() => {
        navigate(stepIndex + 1);
    }, [navigate, stepIndex]);

    const navigateBack = useCallback(() => {
        navigate(stepIndex - 1);
    }, [navigate, stepIndex]);

    return {
        isFirstStep: stepIndex === 0,
        isLastStep: wizardSteps.length - 1 === stepIndex,
        navigateNext,
        navigateBack,
    };
};
